import { createElement } from 'react';
import { useDispatch } from 'react-redux';
import { ActionType, RouteName } from '@mews-commander/enums';
import { useResolveRoute } from '@mews/routing';
import { openModal } from '../../../../../modules/app/actions/common';
import { BillHeadingAction } from './types';

interface ChangeBillingDetailsActionProps {
    action: BillHeadingAction<ActionType.ChangeBillingDetailsAction>;
    component: React.ElementType;
    close: () => void;
}
export const ChangeBillingDetailsAction = ({ action, component, close }: ChangeBillingDetailsActionProps) => {
    const dispatch = useDispatch();
    const resolveRoute = useResolveRoute();

    const openChangeBillingDetailsForm = () => {
        if (close) {
            close();
        }
        dispatch(openModal(resolveRoute(RouteName.BillChangeAddress, { billId: action.billId })));
    };

    return createElement(component, {
        'data-test-id': 'change-billing-details-action',
        title: action.text,
        icon: action.icon,
        onClick: openChangeBillingDetailsForm,
    });
};
